import { init } from '@sentry/vue'

export default function initSentryVue(app: any) {
  if (process.env.IS_DEV) {
    return
  }

  init({
    app,
    dsn: process.env.IS_PROD
      ? 'https://2b1d65ad9d054a29b1e25882be30f587@sentry.medrocket.me/93'
      : 'https://80c535a9322049fb8ad03a5da06ca427@sentry.prodoctorov.com/59',
    tracesSampleRate: 1.0,
    normalizeDepth: 10,
    autoSessionTracking: false,
  })
}
